// extracted by mini-css-extract-plugin
export var wrapper = "SeeSalmon-module--wrapper--3W83k";
export var container = "SeeSalmon-module--container--2FKNP";
export var texts = "SeeSalmon-module--texts--3CH5q";
export var logo = "SeeSalmon-module--logo--3O3J0";
export var image = "SeeSalmon-module--image--GSlio";